module.exports = __webpack_public_path__ + "static/media/monster-error.0f5d7219.gif";